<template>
    <div>
        <div class="form">
            <!-- Título dinámico según producto -->
            <div class="titleStep" v-if="formData.product_type === 'fresh'">
                <h1>¿Cuánto pesa {{formData.petname}}?</h1>
                <p>Necesitamos su peso exacto para calcular las porciones perfectas de comida fresca.</p>
            </div>
            <div class="titleStep" v-else>
                <h1>¿Qué tan grande es {{formData.petname}}?</h1>
                <p>Ayúdanos a seleccionar el tamaño adecuado</p>
            </div>
            
            <div class="wrap weight-selector">
                <div class="weight-display">
                    <h2 class="weight-number">{{form.weight}} kg</h2>
                    <p class="weight-label">Peso actual</p>
                </div>
                
                <div class="slider-container">
                    <b-field>
                        <b-slider 
                            v-model="form.weight" 
                            :min="1" 
                            :max="50" 
                            :step="0.5"
                            :custom-formatter="val => `${val} kg`"
                            size="is-large"
                            type="is-primary"
                        >
                            <b-slider-tick :value="1">1kg</b-slider-tick>
                            <b-slider-tick :value="10">10kg</b-slider-tick>
                            <b-slider-tick :value="20">20kg</b-slider-tick>
                            <b-slider-tick :value="30">30kg</b-slider-tick>
                            <b-slider-tick :value="40">40kg</b-slider-tick>
                            <b-slider-tick :value="50">50kg</b-slider-tick>
                        </b-slider>
                    </b-field>
                </div>
                
                <!-- Recomendación solo para Fresh -->
                <div class="plan-recommendation" v-if="formData.product_type === 'fresh'">
                    <p class="recommendation-label">Plan recomendado:</p>
                    <div class="recommendation-badge" :class="planClass">
                        <strong>{{recommendedPlan}}</strong>
                        <span>{{recommendedPortions}} porciones/mes</span>
                    </div>
                </div>
                
                <div class="column is-12 v-column" v-if="$v.form.weight.$error">
                    <p class="help is-danger">Por favor selecciona el peso de {{formData.petname}}</p>
                </div>
            </div>
            
            <b-button 
                id="step-two-continue" 
                type="is-primary nextButton" 
                @click="nextStep"
            >
                Continuar
            </b-button>
            <a class="backStep" @click="backStep">Volver</a>
        </div>
    </div>
</template>

<script>
    import {validationMixin} from 'vuelidate'
    import {required, between} from 'vuelidate/lib/validators'
    import StepMixin from '../../mixins/StepMixin'

    export default {
        props: ['clickedNext', 'currentStep'],
        mixins: [validationMixin, StepMixin],
        data() {
            return {
                form: {
                    weight: 10, // Default 10kg
                    size: 'Medium', // Para compatibilidad con emails
                }
            }
        },
        watch: {
            'form.weight': function(newWeight) {
                // Auto-calcular size cuando cambia weight
                if (newWeight <= 7) {
                    this.form.size = 'Little';
                } else if (newWeight <= 15) {
                    this.form.size = 'Medium';
                } else {
                    this.form.size = 'Big';
                }
            }
        },
        computed: {
            formData(){
                return this.$parent.$parent.$parent.formData 
            },
            recommendedPlan() {
                if (this.form.weight <= 7) return 'Pequeño';
                if (this.form.weight <= 15) return 'Mediano';
                if (this.form.weight <= 30) return 'Grande';
                return 'Gigante';
            },
            recommendedPortions() {
                if (this.form.weight <= 7) return '7';
                if (this.form.weight <= 15) return '14';
                if (this.form.weight <= 30) return '28';
                return '49';
            },
            planClass() {
                if (this.form.weight <= 7) return 'plan-small';
                if (this.form.weight <= 15) return 'plan-medium';
                if (this.form.weight <= 30) return 'plan-large';
                return 'plan-giant';
            }
        },
        validations: {
            form: {
                weight: { 
                    required,
                    between: between(1, 50)
                },
            }
        },
    }
</script>

<style scoped>
.weight-selector {
    padding: 2rem 0;
}

.weight-display {
    text-align: center;
    margin-bottom: 3rem;
}

.weight-number {
    font-size: 4rem;
    font-weight: bold;
    color: #3498db;
    margin: 0;
    line-height: 1;
}

.weight-label {
    font-size: 1.2rem;
    color: #7f8c8d;
    margin-top: 0.5rem;
}

.slider-container {
    margin: 2rem 0;
    padding: 0 1rem;
}

.plan-recommendation {
    text-align: center;
    margin-top: 2rem;
    padding: 1.5rem;
    background: #f8f9fa;
    border-radius: 12px;
}

.recommendation-label {
    font-size: 0.9rem;
    color: #7f8c8d;
    margin-bottom: 0.5rem;
    text-transform: uppercase;
    letter-spacing: 1px;
}

.recommendation-badge {
    display: inline-block;
    padding: 1rem 2rem;
    border-radius: 8px;
    transition: all 0.3s ease;
}

.recommendation-badge strong {
    display: block;
    font-size: 1.5rem;
    margin-bottom: 0.25rem;
}

.recommendation-badge span {
    font-size: 1rem;
    opacity: 0.8;
}

.plan-small {
    background: #e3f2fd;
    color: #1976d2;
}

.plan-medium {
    background: #e8f5e9;
    color: #388e3c;
}

.plan-large {
    background: #fff3e0;
    color: #f57c00;
}

.plan-giant {
    background: #f3e5f5;
    color: #7b1fa2;
}

@media (max-width: 768px) {
    .weight-number {
        font-size: 3rem;
    }
    
    .slider-container {
        padding: 0 0.5rem;
    }
}
</style>
